import Grid from '@jobcost-monorepo/crud/ui/Grid';
import { IListCustomerFetchParams, MN_CUSTOMERS } from '@jobcost-monorepo/crud';
import { ICustomer } from '@jobcost-monorepo/crud/dto/customer';

export default function CustomersPage() {
  return (
    <Grid<ICustomer, IListCustomerFetchParams>
      moduleName={MN_CUSTOMERS}
      updateStore={false}
    ></Grid>
  );
}
